module.exports = __webpack_public_path__ + "static/media/snap.4e0d6fd5.svg";